import request from '@/utils/request'

/**
 * 获取父租户
 */
export const getAllTenantData = async (params) => {
  return await request({
    url: '/sys/v1/tenant/page',
    method: 'GET',
    params
  })
}

export const getAllTenant = async () => {
  return await request({
    url: '/sys/v1/findAllTenant',
    method: 'GET'
  })
}
/**
 * 获取子租户
 * @param {*} data
 * @returns
 */
export const getEnterpriseByTenantId = async (params) => {
  return await request({
    url: '/sys/v1/enterprise/page',
    method: 'GET',
    params
  })
}

/**
 * 新增租户
 */
export const addTenant = (data) => {
  return request({
    url: '/sys/v1/tenant/add',
    method: 'POST',
    data
  })
}

/**
 * 修改租户
 */
export const updateTenant = (data) => {
  return request({
    url: '/sys/v1/tenant',
    method: 'POST',
    data
  })
}

/**
 * 新增修改诊所
 * @param {*} data
 */
export const addEnterprise = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/enterprise',
    data
  })
}

/**
 * 删除租户
 */
export const delTenant = async (tenantId) => {
  return await request({
    url: `/sys/v1/tenant/${tenantId}`,
    method: 'DELETE'
  })
}

/**
 * 删除诊所
 * @param {*} tenantId
 * @returns
 */
export const delEnterprise = (tenantId) => {
  return request({
    url: `/sys/v1/enterprise/${tenantId}`,
    method: 'DELETE'
  })
}

/**
 * 感觉诊所id查询对应的租户id
 * @param {*} clinicId
 * @returns
 */
export const getTenantInfoByClinicId = (clinicId) => {
  return request({
    url: `/sys/v1/tenant/clinic/${clinicId}`
  })
}

/**
 * 根据tenantId查询租户信息
 * @param {*} tenantId
 * @returns
 */
export const getTenantInfo = (tenantId) => {
  return request({
    url: `/sys/v1/tenant/${tenantId}`
  })
}

/**
 * 通过clinicId得到显示的诊所信息
 */
export const getWxClinicInfo = (clinicId) => {
  return request({
    url: `yia/v1/wx_clinic/info/${clinicId}`,
    method: 'GET'
  })
}

/**
 * 保存诊所微信信息
 */
export const savaClinicInfo = (data) => {
  return request({
    url: 'yia/v1/wx_clinic/save',
    method: 'POST',
    data
  })
}

export const getUserPageListByTenantId = (tenantId = 1, data) => {
  return request({
    url: `/sys/v1/user/getTenantUserPageList/${tenantId}`,
    params: data
  })
}

/**
 * 根据门诊id，获取后台门诊分配的账号
 * @param {*} clinicId
 * @returns
 */
export const getClinicUserPage = (clinicId, params) => {
  return request({
    url: `/sys/v1/user/getClinicUserPageList/${clinicId}`,
    params
  })
}

/**
 * 获取诊所介绍信息
 * @param {*} data
 * @returns
 */
export const getClinicIntroPage = (data) => {
  return request({
    url: 'yia/v1/wx_clinic/page',
    params: data
  })
}

/**
 * 查询租户以及租户下的子门诊
 * @param {*} params
 * @returns
 */
export const getTenantAndClinicPage = (params) => {
  return request({
    url: '/sys/v1/tenant/page-plus',
    params
  })
}

/**
 * 上传门诊对应图片
 * @param {*} data
 * @param {*} tenantId
 * @returns
 */
export const uploadTenantImage = (data, tenantId = 0) => {
  return request({
    method: 'POST',
    url: `yia/v1/wx_clinic/uploadClinicImage/${tenantId}`,
    data
  })
}

/**
 * 查询B端租户用户分页
 * @param {*} data
 * @returns
 */
export const findHisLoginUserPage = (data) => {
  return request({
    method: 'GET',
    url: '/sys/v1/hisLoginUser/findHisLoginUserPage',
    params: data
  })
}

/**
 * 开通租户用户账号
 * @param {*} data
 * @returns
 */
export const addTenantManager = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/hisLoginUser/add-tenantManager',
    data
  })
}

/**
 * 修改租户用户账号
 * @param {*} data
 * @returns
 */
export const updateTenantManager = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/hisLoginUser/update-tenantManager',
    data
  })
}

// 线索基础配置同步
export const asyncClueConfig = (tenantId) => {
  return request({
    url: `/sys/v1/clinicDict/clueConfig/${tenantId}`
  })
}

/**
 * 搜索卫监配置明细
 * @param {*} data
 * @returns
 */
export const getWjConfigDetail = (data) => {
  return request({
    url: '/sys/v1/wjConfig/detail',
    method: 'POST',
    data
  })
}

/**
 * 新增/修改配置
 * @param {*} data
 * @returns
 */
export const saveOrUpdWjConfig = (data) => {
  return request({
    url: '/sys/v1/wjConfig/saveOrUpd',
    method: 'POST',
    data
  })
}

/**
 * 卫监类型列表
 * @param {*} data
 * @returns
 */
export const getWjTypeList = () => {
  return request({
    url: '/sys/v1/wjConfig/type',
    method: 'POST'
  })
}
